import { decode, isValid as isValidBase64 } from 'js-base64';

export function tryDecodeBase64(value: string): string {
	return isValidBase64(value) ? decode(value) : value;
}
